import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/customer/update/user.customer.update.mutation.gql"
import type {
  UserCustomerUpdateMutation,
  UserCustomerUpdateMutationVariables,
} from "@/v2-backoffice-client/user/customer/update/__types__/user.customer.update.mutation"

type Options = MutationHookOptions<
  UserCustomerUpdateMutation,
  UserCustomerUpdateMutationVariables
>

export function useUserCustomerUpdateMutation(options?: Options) {
  return useMutation<
    UserCustomerUpdateMutation,
    UserCustomerUpdateMutationVariables
  >(mutation, options)
}
